// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import List from '../_raw/ui/icon_list.svg';
import withIconProps from '../withIconProps';

export default withIconProps(List);
